// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2349":"78ea882e","2936":"6c7b3e7f","5456":"1e7b30a4","9735":"1e7b30a4"}[chunkId] + ".chunk.css";
};